export default __webpack_public_path__ + "static/media/Trash Disposal.ee10e272.png";